import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectorItem } from '@app/component/selector/selector.component';
import { Currency } from '@app/model/currency';
import { RouteComponent } from '@app/route/route.component';
import { HeaderService } from '@app/service/header/header.service';
import { StateService } from '@app/service/state/state.service';
import { UserService } from '@app/service/user-service/user.service';
import { ValuePipe } from '@app/shared/pipe/value.pipe';
import { Market } from '@app/model/payment-request/payment-request.dto';
import { LoanOption } from '@app/route/shared/LoanOption';
import { DeLoanOptionService } from '@app/service/de-loan-option/de-loan-option.service';
import { Color } from 'web-component-library/projects/component-library/src/public-api';

@Component({
  selector: 'app-de-confirm-collective-invoice',
  templateUrl: './de-confirm-collective-invoice.component.html',
  styleUrls: [
    '../../../route/page-shared.css',
    './de-confirm-collective-invoice.component.scss',
  ],
})
export class DeConfirmCollectiveInvoice extends RouteComponent {
  navigationInProgress = false;
  totalCheckoutValue: Currency = null;
  merchantName = '';
  selectorItems: SelectorItem[] = null;
  modalActive = false;
  ButtonColor = Color;
  selectedItem: SelectorItem = null;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected headerService: HeaderService,
    protected stateService: StateService,
    protected userService: UserService,
    private valuePipe: ValuePipe,
    private loanOptionService: DeLoanOptionService
  ) {
    super(router, route, stateService, headerService);
  }

  ngOnInit(): void {
    this.navigationInProgress = false;
    this.totalCheckoutValue = this.state.totalCheckoutValue;
    this.merchantName = this.state.checkoutCustomizations.merchantName;
    this.prepareModalInformation();
  }

  async handleCtaClick() {
    this.navigationInProgress = true;

    try {
      this.userService.chargeCollectiveInvoice().then(() => {
        this.navigate();
      });
    } catch (err) {
      this.handleError(err);
    }
  }

  toggleModal(index: number): void {
    this.selectedItem = this.selectorItems[index];
    this.modalActive = !this.modalActive;
  }

  prepareModalInformation(): void {
    if (
      this.state.loanOptions &&
      this.state.loanOptions.length > 0 &&
      this.state.loanOptions[0].termId
    ) {
      const selectedLoanOption = this.state.loanOptions.find(
        (loanOption: LoanOption) => loanOption.termId
      );

      if (selectedLoanOption) {
        const currentLoanTermsStr = this.loanOptionService.buildLoanTermsString(
          selectedLoanOption,
          this.state.totalCheckoutValue
        );

        this.selectorItems = [
          {
            tab: 'Zahlungsbedingungen',
            title: 'Bedingungen für den Kauf auf Raten',
            descriptions: [{ text: currentLoanTermsStr }],
            links: [
              {
                text: 'Bedingungen für Teilzahlungen',
                onClick: () =>
                  this.openURLinNewWindow(selectedLoanOption.loanTermsURL),
              },
              {
                ...(this.state.checkoutCustomizations.merchantTermsUrl !==
                  null &&
                  this.state.checkoutCustomizations.merchantName !== null && {
                    text: this.stateService.getCustomTermsUrlText(
                      this.state.checkoutCustomizations.merchantName + ' AGB',
                      this.state.checkoutCustomizations
                    ),
                    onClick: () =>
                      this.openURLinNewWindow(
                        this.state.checkoutCustomizations.merchantTermsUrl
                      ),
                  }),
              },
              {
                ...(this.state.market === Market.AT && {
                  text: 'Europäische Standardinformationen für Kreditierungen nach dem Verbraucherkreditgesetz',
                  onClick: () =>
                    this.openURLinNewWindow(selectedLoanOption.secciURL),
                }),
              },
            ],
          },
        ];
      }
      this.getModalPurchaseInfo();
    }
  }

  openURLinNewWindow(url: string): void {
    window.open(url, '_blank');
  }

  deactivateModal(): void {
    this.modalActive = false;
  }

  getModalPurchaseInfo(): void {
    this.selectorItems = [
      {
        tab: 'Ihr Kauf',
        title: 'Zusammenfassung',
        lineItems: this.state.paymentInformation?.lineItems,
        totalValue: this.stateService.getCustomTaxTypeText(
          `Gesamtbetrag inkl. MwSt: ${this.valuePipe.transform(
            this.state.totalCheckoutValue
          )}`,
          this.state.checkoutCustomizations
        ),
      },
      ...this.selectorItems,
    ];
  }
}
